'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$() {
}
export { $c_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ as $c_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ };
$p = $c_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$;
/** @constructor */
function $h_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$() {
}
export { $h_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ as $h_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ };
$h_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$.prototype = $p;
$p.eu = (function() {
  return 0;
});
var $d_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$, "samples.package$package$ExtraInt$given_Defaultable_ExtraInt$", ({
  ri: 1,
  aR: 1
}));
export { $d_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ as $d_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ };
var $n_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$;
function $m_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$() {
  if ((!$n_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$)) {
    $n_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ = new $c_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$();
  }
  return $n_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$;
}
export { $m_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ as $m_Lsamples_package$package$ExtraInt$given\uff3fDefaultable\uff3fExtraInt$ };
